import React from "react";
import { Avatar, Box, Chip, Typography, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { UserRoleName } from "../../../../themes/Enum";
import useAuthUser from "../../../../hooks/useAuthUser";

const SidebarUserCard = ({ collapsed }) => {
  const theme = useTheme();
  const sidebar = theme.palette.sidebar;

  const userData = useAuthUser() || {};
  const userName = userData.name || userData.fullName || "User";
  const userRole = UserRoleName[userData.rol] || "User";
  const userInitial = userName.charAt(0).toUpperCase();

  if (collapsed) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 1.5 }}>
        <Tooltip title={`${userName} - ${userRole}`} placement="right" arrow>
          <Avatar
            sx={{
              width: 36,
              height: 36,
              background: "linear-gradient(135deg, #00bcd4 0%, #0C343D 100%)",
              fontSize: "0.9rem",
              fontWeight: 600,
            }}
          >
            {userInitial}
          </Avatar>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mx: 1.5,
        my: 1,
        p: 1.5,
        borderRadius: 2,
        backgroundColor: sidebar.userCardBg,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      <Avatar
        sx={{
          width: 40,
          height: 40,
          background: "linear-gradient(135deg, #00bcd4 0%, #0C343D 100%)",
          fontSize: "1rem",
          fontWeight: 600,
          flexShrink: 0,
        }}
      >
        {userInitial}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="body2"
          sx={{
            color: sidebar.activeText,
            fontWeight: 600,
            lineHeight: 1.3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {userName}
        </Typography>
        <Chip
          label={userRole}
          size="small"
          sx={{
            mt: 0.3,
            height: 20,
            fontSize: "0.65rem",
            fontWeight: 500,
            backgroundColor: "rgba(0,188,212,0.15)",
            color: "#00bcd4",
            borderRadius: 1,
          }}
        />
      </Box>
    </Box>
  );
};

export default SidebarUserCard;
